import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AUDIT_LOG_SEARCH_RESOURCE } from "../audit-log/use-audit-log-search.query";

export const RELOCATION_ORDER_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_FLOW_RESOURCE = "relocation-order/flow" as const;
export const RELOCATION_ORDER_FLOW_UNLOAD_AT_LAYOVER_OPERATION = "unload-at-layover" as const;
export const RELOCATION_ORDER_FLOW_UNLOAD_AT_LAYOVER_API_PATH =
  `/v1/${RELOCATION_ORDER_FLOW_RESOURCE}/{uuid}/${RELOCATION_ORDER_FLOW_UNLOAD_AT_LAYOVER_OPERATION}` as const;

export type UnloadAtLayoverBody =
  paths[typeof RELOCATION_ORDER_FLOW_UNLOAD_AT_LAYOVER_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type UnloadAtLayoverResponse =
  paths[typeof RELOCATION_ORDER_FLOW_UNLOAD_AT_LAYOVER_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useRelocationOrderFlowUnloadAtLayoverMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<UnloadAtLayoverResponse, Error, UnloadAtLayoverBody & { uuid: string }>({
    mutationFn: async ({ uuid, ...body }: UnloadAtLayoverBody & { uuid: string }) => {
      const response = await alphartisApiAxios.patch<UnloadAtLayoverResponse>(
        `/v1/${RELOCATION_ORDER_FLOW_RESOURCE}/${uuid}/${RELOCATION_ORDER_FLOW_UNLOAD_AT_LAYOVER_OPERATION}`,
        body,
      );
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [RELOCATION_ORDER_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [AUDIT_LOG_SEARCH_RESOURCE],
        }),
      ]);
    },
  });
};
